var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageCareHistoryMedicationHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 133 111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 133c36.727 0 66.5-29.773 66.5-66.5C133 29.773 103.227 0 66.5 0 29.773 0 0 29.773 0 66.5 0 103.227 29.773 133 66.5 133Z",
    fill: "#FDD59E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.314 121.548h47.734a8.446 8.446 0 0 0 5.97-2.472 8.447 8.447 0 0 0 2.472-5.97v-10.3c-2.05-15.737-1.907-29.657 0-46.25v-9.26l-52.232-8.252-12.386 46.65v27.415a8.444 8.444 0 0 0 8.442 8.439Z",
    fill: "#FFBE71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.49 56.55H37.13a6.653 6.653 0 0 0-6.653 6.653v32.945a6.65 6.65 0 0 0 4.107 6.146 6.641 6.641 0 0 0 2.546.507h42.36v-46.25Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.781 74.354h-7.934V66.42H50.203v7.934h-7.934v10.644h7.934v7.934h10.644v-7.934h7.934V74.353Z",
    fill: "#F74F73"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.872 32.497H79.49v14.795H14.872V32.497Z",
    fill: "#EF8E4D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.63 41.043h52.786v-11.38a6.58 6.58 0 0 0-6.581-6.578H39.77c-3.554 6.13-6.26 12.156-7.14 17.958Z",
    fill: "#FFBE71"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.527 23.085a6.58 6.58 0 0 0-6.577 6.58v11.38H32.63l7.142-17.957-24.246-.003Z",
    fill: "#EF8E4D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.027 32.497H14.872V85.69l21.155-53.193Z",
    fill: "#EF8E4D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m107.08 82.104 7.142 3.45a5.1 5.1 0 0 1-4.436 9.183h-.001l-7.141-3.45c.942-3.676 2.292-6.883 4.436-9.183Z",
    fill: "#BDDEFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m99.94 78.654 7.14 3.45-4.437 9.183-7.14-3.45a5.1 5.1 0 0 1 4.435-9.183h.001Z",
    fill: "#7AAEED"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m98.046 114.168-6.95 3.536h-.002a5.012 5.012 0 0 1-7.04-6.022 5.015 5.015 0 0 1 2.495-2.916l6.951-3.536c2.154 2.218 3.546 5.343 4.546 8.938Z",
    fill: "#BDDEFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M100.451 101.695a5.015 5.015 0 0 1 4.545 8.938l-6.95 3.535-4.546-8.937 6.95-3.535.001-.001Z",
    fill: "#7AAEED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageCareHistoryMedicationHistory);
export default __webpack_public_path__ + "static/media/image_care_history_medication_history.3e935637.svg";
export { ForwardRef as ReactComponent };